/**
 * src/auth/msalInstance.js
 *
 * Singleton MSAL PublicClientApplication, extracted from index.js so that
 * non-React code (plain api modules) can import the instance and acquire
 * tokens without a React hook (useMsal is render-only).
 *
 * getApiToken() acquires an ACCESS token for the custom API scope
 * (REACT_APP_API_SCOPE) at token-time — the login request stays
 * ["openid","profile"]; we do NOT request the API scope at login.
 */

import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalConfig } from '../authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export async function getApiToken() {
  const account = msalInstance.getAllAccounts()[0];
  if (!account) return null;
  const scope = process.env.REACT_APP_API_SCOPE;
  try {
    const res = await msalInstance.acquireTokenSilent({ scopes: [scope], account });
    return res.accessToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ scopes: [scope] });
      return null; // redirect navigates away
    }
    throw e;
  }
}
